/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Connect_Signin_LedeInputs */

const en_mcp_connect_signin_lede = /** @type {(inputs: Mcp_Connect_Signin_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the account you want to connect. You’ll review what the app can access next.`)
};

const es_mcp_connect_signin_lede = /** @type {(inputs: Mcp_Connect_Signin_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa la cuenta que quieres conectar. A continuación revisarás a qué podrá acceder la app.`)
};

/**
* | output |
* | --- |
* | "Use the account you want to connect. You’ll review what the app can access next." |
*
* @param {Mcp_Connect_Signin_LedeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_signin_lede = /** @type {((inputs?: Mcp_Connect_Signin_LedeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Signin_LedeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_signin_lede(inputs)
	return en_mcp_connect_signin_lede(inputs)
});